import React, { useContext } from 'react';
import classNames from 'classnames';
import classes from './ThirdPartyLinkPreview.module.scss';
import { ThirdPartyPostLinkFieldsFragment } from '../../../../models/graphql';
import { Badge } from '../../../../components/containers/Badge';
import { FindContentContext } from '../FindContentProvider';
import { buildBadgeProps, extractLinkUrlDetails } from '../findContentHelpers';

export enum ThirdPartyLinkPreviewContextEnum {
  CARD = 'CARD',
  MODAL = 'MODAL'
}

export type ThirdPartyLinkPreviewViewProps = Omit<ThirdPartyPostLinkFieldsFragment, '__typename'> & {
  context?: ThirdPartyLinkPreviewContextEnum;
  hasTooltipBadge?: boolean;
};

export const ThirdPartyLinkPreviewView = ({
  linkUrl,
  linkName,
  linkDescription,
  context,
  hasTooltipBadge
}: ThirdPartyLinkPreviewViewProps): JSX.Element => {
  const { platform } = useContext(FindContentContext);
  const truncateLinkUrl = platform === 'RSS';
  const urlDetails = extractLinkUrlDetails(String(linkUrl));

  if (!urlDetails) return <></>;

  const { domain } = urlDetails;
  const badgeProps = buildBadgeProps(urlDetails, truncateLinkUrl, !!hasTooltipBadge);

  const bannerClasses = classNames(classes.Banner, {
    [classes.BannerInCard]: context === ThirdPartyLinkPreviewContextEnum.CARD,
    [classes.BannerInModal]: context === ThirdPartyLinkPreviewContextEnum.MODAL
  });

  return (
    <div className={classes.ThirdpartylinkPreview}>
      {linkName ? (
        <div className={bannerClasses}>
          <div className={classes.LinkTitle}>{linkName}</div>
          {context === ThirdPartyLinkPreviewContextEnum.MODAL && (
            <div className={classes.LinkDescription}>{linkDescription}</div>
          )}
          <div
            className={classes.LinkUrl}
            onClick={() => window.open(urlDetails.url.href, '_blank', 'noopener,noreferrer')}>
            {domain}
          </div>
        </div>
      ) : (
        <div className={classes.BadgeWrapper}>
          <Badge {...badgeProps} />
        </div>
      )}
    </div>
  );
};
